import { Platform } from "react-native";

import { caesarCipher, getCoordinates, getAccelerometerReadings } from "utils";
import { FeedbackOptionSerializer } from "serializers";

const isNative = Platform.OS !== "web";

export const FeedbackSerializer = async (state, isComplete = true) => {
  const {
    survey,
    division,
    response,
    organization,
    taker,
    network,
    customer,
  } = state;
  const feedback_options = FeedbackOptionSerializer(response);
  let demographics = { ...state.app.demographics };
  if (isNative) {
    demographics.coordinates = await getCoordinates();
  }
  const user_session =
    organization.track_taker_session && state.taker.id
      ? state.taker.sessionId
      : null;

  const accReadings = await getAccelerometerReadings();

  let embedLinkProps = {};
  if (survey.isAppEmbed) {
    embedLinkProps = {
      customer: {
        name: customer?.name,
        email: customer?.email,
        cell_phone: customer?.cell_phone,
        extras: customer?.extras,
      },
    };
  }

  return {
    assignee: state.organization.assignee_id,
    feedback_options,
    organization: organization.id,
    questionnaireId: survey.questionnaireId,
    user_session,
    division: division.id,
    dz: accReadings.dz,
    dy: accReadings.dy,
    dx: accReadings.dx,
    duration: new Date().getTime() - survey.startTime,
    products: [],
    created_at: new Date(),
    taker: taker.id,
    invite: survey.inviteId,
    stage_number: survey.stage,
    is_complete: isComplete,
    device: state.app.device,
    review: state.feedback.review,
    demographics: caesarCipher(JSON.stringify(demographics)),
    ...embedLinkProps,
    ...network.networkInfo,
  };
};
